import { all, fork } from 'redux-saga/effects';
import mediaSaga from './media.saga';
import metadataSaga from './metadata.saga';
import TierSaga from './tier.saga';
import ProjectSaga from './project.saga';
import AuthSaga from './auth.saga';

export default function* rootSaga() {
  yield all([fork(mediaSaga), fork(metadataSaga), fork(TierSaga), fork(ProjectSaga), fork(AuthSaga)]);
}
